import { legacy } from '@/shared/api/client';
import type { ObservabilityList, SecurityException, SecurityFixType, SecurityList } from '../model/types';

export interface ObservabilityFilters {
  provider: string;
  direction: string;
  status: string;
  q: string;
}

/** Lista as trocas de integração. No mock, GET /bff/api/observability/integrations. */
export async function fetchObservabilityIntegrations(filters: ObservabilityFilters): Promise<ObservabilityList> {
  const params = new URLSearchParams();
  if (filters.provider !== 'all') params.set('provider', filters.provider);
  if (filters.direction !== 'all') params.set('direction', filters.direction);
  if (filters.status !== 'all') params.set('status', filters.status);
  if (filters.q.trim()) params.set('q', filters.q.trim());
  const qs = params.toString();
  return legacy.get<ObservabilityList>(`/observability/integrations${qs ? `?${qs}` : ''}`);
}

export interface ObservabilityRetention {
  enabled: boolean;
  intervalDays: number;
  lastRunAt: string | null;
  lastDeleted: number;
}

export async function fetchObservabilityRetention(): Promise<ObservabilityRetention> {
  return legacy.get<ObservabilityRetention>('/observability/retention');
}

export async function updateObservabilityRetention(
  payload: Pick<ObservabilityRetention, 'enabled' | 'intervalDays'>,
): Promise<ObservabilityRetention> {
  return legacy.put<ObservabilityRetention>('/observability/retention', payload);
}

/** Aba Segurança: o que os ajustes do pentest recusaram e as liberações ativas. */
export async function fetchSecurity(): Promise<SecurityList> {
  return legacy.get<SecurityList>('/observability/security');
}

export async function createSecurityException(payload: {
  type: SecurityFixType;
  value: string;
  note?: string;
}): Promise<{ exceptions: SecurityException[] }> {
  return legacy.post<{ exceptions: SecurityException[] }>('/observability/security/exceptions', payload);
}

export async function deleteSecurityException(id: string): Promise<{ exceptions: SecurityException[] }> {
  return legacy.delete<{ exceptions: SecurityException[] }>(
    `/observability/security/exceptions/${encodeURIComponent(id)}`,
  );
}
